import { BaseResource } from "../base-resource";
import { CustomFunctionAction } from "./custom-function-action";

export class UserDefinedFunction extends BaseResource {
    functionName: string;
    externalJSUrl: string;
    inlineFunction: string;
    customFunctionAction: CustomFunctionAction;
}
